// extracted by mini-css-extract-plugin
export default {"title":"NewPassword_title__9-Alq"};